<app-header></app-header>
<div class="min-h-[100vh]">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>